export const POST_GENERATE_PETITIONS_CSV_REQUEST = 'POST_GENERATE_PETITIONS_CSV_REQUEST';
export const POST_GENERATE_PETITIONS_CSV_SUCCESS = 'POST_GENERATE_PETITIONS_CSV_SUCCESS';
export const POST_GENERATE_PETITIONS_CSV_FAILED = 'POST_GENERATE_PETITIONS_CSV_FAILED';

export const GET_PETITION_CSV_GENERATION_JOB_REQUEST = 'GET_PETITION_CSV_GENERATION_JOB_REQUEST';
export const GET_PETITION_CSV_GENERATION_JOB_SUCCESS = 'GET_PETITION_CSV_GENERATION_JOB_SUCCESS';
export const GET_PETITION_CSV_GENERATION_JOB_FAILED = 'GET_PETITION_CSV_GENERATION_JOB_FAILED';

export const RESET_GENERATE_PETITIONS_CSV = 'RESET_GENERATE_PETITIONS_CSV';
